import t from 'react-translate';
import { css } from '@emotion/react';
import { GoalItemStatus, MentoringProgramGoalItem } from 'redux/schemas/models/mentoring-program-goal-items';
import { gray6 } from 'styles/global_defaults/colors';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';
import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import DeleteGoalOption from './delete-goal-option';
import ChangeStatusOption from './change-status-option';
import { optionStyles } from './styles';
import { config } from '@config/pendo.config.json';

type GoalMenuProps = {
  isReadOnly: boolean;
  item: MentoringProgramGoalItem;
  disabled: boolean;
  isEditing: boolean;
  status: GoalItemStatus;
  onChange: () => void;
  onDelete: () => void;
};

const editStyles = css`
  ${optionStyles}
  margin: 1px;
  padding: ${quarterSpacing}px;

  &.disabled {
    pointer-events: none;
    background: ${gray6} !important;
  }
`;

const menuStyles = css`
  gap: ${halfSpacing}px;
`;

const GoalMenu = ({ isReadOnly, item, disabled, status, isEditing, onChange, onDelete }: GoalMenuProps) => {
  const { id: itemId } = item;
  const dataQATagBase = config.pendo.athena.mentorshipProgram.participantHome.goals.list.item;
  const dataQATag = itemId ? dataQATagBase.updateGoalCheckButton : dataQATagBase.createNewGoalAddButton;
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.ARIA_LABEL;
  const ariaLabel = itemId ? translationBase.UPDATE_GOAL() : translationBase.ADD_GOAL();

  if (isEditing) {
    return (
      <ClickableContainer
        disabled={disabled}
        css={editStyles}
        className={disabled ? 'disabled' : ''}
        onClick={onChange}
        data-qa={dataQATag}
        data-qa-id={`${dataQATag}-${itemId}`}
        aria-label={ariaLabel}
      >
        <NvIcon icon={itemId ? 'check' : 'create-new-post'} size='smallest' />
      </ClickableContainer>
    )
  }

  if (itemId) {
    return (
      <div css={menuStyles} className='d-flex align-items-center'>
        <ChangeStatusOption isReadOnly={isReadOnly} status={status} goalItemId={itemId} />
        <DeleteGoalOption isReadOnly={isReadOnly} goalItemId={itemId} onDelete={onDelete} />
      </div>
    );
  }
  return null;
}

export default GoalMenu;
